import { EventType } from 'types'

export const eventTypes: Record<string, any>[] = [
  {
    title: 'ГВ Левая',
    icon: 'BreastLeftIcon',
    type: EventType.BREAST_LEFT,
    color: 'var(--red-primary)',
  },
  {
    title: 'ГВ Правая',
    icon: 'BreastRightIcon',
    type: EventType.BREAST_RIGHT,
    color: 'var(--green-tertiary)',
  },
  {
    title: 'Бутылочка',
    icon: 'FeedBottleIcon',
    type: EventType.BOTTLE,
    color: 'var(--yellow-primary)',
  },
  {
    title: 'Дневной сон',
    icon: 'SleepIcon',
    type: EventType.SLEEP_DAY,
    color: 'var(--blue-quaternary)',
  },
  {
    title: 'Ночной сон',
    icon: 'SleepIcon',
    type: EventType.SLEEP_NIGHT,
    color: 'var(--blue-quaternary)',
  },
  {
    title: 'Ка-ка',
    icon: 'PoopIcon',
    type: EventType.POO,
    color: 'var(--black)',
  },
  {
    title: 'Пи-пи',
    icon: 'PeeIcon',
    type: EventType.PEE,
    color: 'var(--black)',
  },
]
